import { $$ } from 'scss-base-sites/src/js/helper';
import { Core } from 'scss-base-sites/src/js/utility';
import { Modal } from 'scss-base-sites/src/js/plugin';

Core.ready(() => $$('.photos > .modal').forEach(modal => new Modal(modal)));
